import React from 'react';
import { Link } from 'react-router-dom';

export function formatDate(iso) {
  return new Date(iso + 'T00:00:00').toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function Cover({ post, eager }) {
  return (
    <img
      src={post.cover}
      alt={post.coverAlt || ''}
      loading={eager ? undefined : 'lazy'}
      style={post.coverPosition ? { objectPosition: post.coverPosition } : undefined}
    />
  );
}

function PostTile({ post }) {
  return (
    <Link className="post-tile" to={`/blog/${post.slug}`}>
      <div className="post-tile-img">
        {post.cover && <Cover post={post} />}
      </div>
      <span className="post-date">{formatDate(post.date)}</span>
      {post.draft && <span className="draft-badge">Draft</span>}
      <h3>{post.title}</h3>
      <p>{post.excerpt}</p>
    </Link>
  );
}

export default PostTile;
